
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.883.004a1.633 1.633 0 00-1.433 1.65V5.83H3.617A3.7 3.7 0 000 9.558v24.989a3.7 3.7 0 003.617 3.73h11.716a1.651 1.651 0 000-3.3H3.617a.387.387 0 01-.417-.43V9.558a.387.387 0 01.417-.43H17.45v.292a1.626 1.626 0 001.6 1.65h7.55a1.626 1.626 0 001.6-1.65v-.292h13.817a.4.4 0 01.433.43v21.69a14.663 14.663 0 00-4.833-2.475A8.771 8.771 0 0041.9 21.21a8.453 8.453 0 10-16.9 0 8.771 8.771 0 004.283 7.562A14.239 14.239 0 0018.917 42.35a1.626 1.626 0 001.6 1.65H46.4a1.626 1.626 0 001.6-1.65 13.787 13.787 0 00-2.35-7.717V9.558a3.717 3.717 0 00-3.633-3.729H28.2V1.652A1.626 1.626 0 0026.6.004h-7.55a1.552 1.552 0 00-.167 0zm1.767 3.3H25v4.469h-4.35zM7.1 15.264a1.653 1.653 0 00.167 3.3h13a1.651 1.651 0 000-3.3h-13a1.553 1.553 0 00-.167 0zm26.35.55a5.4 5.4 0 11-5.25 5.4 5.3 5.3 0 015.25-5.4zM7.1 21.382a1.653 1.653 0 00.167 3.3h9.217a1.651 1.651 0 000-3.3H7.267a1.554 1.554 0 00-.167 0zm0 6.118a1.653 1.653 0 00.167 3.3h13a1.651 1.651 0 000-3.3h-13a1.554 1.554 0 00-.167 0zm26.35 3.97a11.361 11.361 0 019.267 4.658l.1.137a10.649 10.649 0 011.8 4.434H22.283a11.143 11.143 0 0111.167-9.228z","fill":"#fff"}})])
          )
        }
      }
    